import { classNames } from "helpers/ClassNameHelper";
import { ControlProps, GroupTypeBase } from "react-select";

export function Control(props: ControlProps<any, boolean, GroupTypeBase<any>>) {
    const getDropdownSize = () => {
        switch (props.selectProps.size) {
            case "large":
                return "dropdown--large";
            case "medium":
                return "dropdown--medium";
            case "small":
                return "dropdown--small";
            default:
                return;
        }
    };

    return (
        <div
            className={classNames(
                "dropdown-container",
                props.isFocused && "dropdown--focused",
                getDropdownSize(),
                !!props.selectProps.errorMessage && "dropdown--error"
            )}
            {...props.innerProps}
        >
            {props.children}
        </div>
    );
}
